<template>
    <div class="na-form">
        <div class="head">{{ tx.Title }}</div>
        <div v-if="workflow" class="left">
            <DxTabPanel>
                <DxItem :title="tx.TabBaseData">
                    <div class="dx-fieldset">
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.WorId }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='workflow.WorId' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.WorName }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='workflow.WorName' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.WorNamePlural }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='workflow.WorNamePlural' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.WorDescription }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='workflow.WorDescription' />
                            </div>
                        </div>

                        <!--<div class="dx-field">
                            <div class="dx-field-label">Mandant:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="ManName" :dataSource="mandantList" :showClearButton='true' valueExpr="ManID" v-model:value="workflow.ManID">
                                </DxSelectBox>
                            </div>

                        </div>-->
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.InitialStatus }}:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="StatusName" :dataSource="statusList" :showClearButton='true' valueExpr="StatusID" v-model:value="workflow.InitialStatusId">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.SubmitStatus }}:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="StatusName" :dataSource="statusList" :showClearButton='true' valueExpr="StatusID" v-model:value="workflow.SubmitStatusId">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.WorChangedOn }}:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='workflow.WorChangedOn' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.WorChangedBy }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='workflow.WorChangedBy' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.WorCreatedOn }}:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='workflow.WorCreatedOn' :readOnly="true" />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.WorCreatedBy }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='workflow.WorCreatedBy' :readOnly="true" />
                            </div>
                        </div>
                    </div>
                </DxItem>
                <DxItem :title="tx.TabWorkflow">
                    <DxDataGrid :data-source="workflowTransition"
                                :key-expr="StatusId"
                                :allow-column-resizing="true"
                                :columns="columns"
                                :filter-row-visible="true"
                                :row-alternation-enabled="true"
                                @row-updating="rowUpdating">
                        <DxEditing :allow-updating="true"
                                   :allow-adding="false"
                                   :allow-deleting="false"
                                   mode="cell" />
                        <DxSearchPanel :visible="true" />
                        <DxGroupPanel :visible="true" />
                    </DxDataGrid>
                </DxItem>
            </DxTabPanel>
            <div class="na-buttons-row">
                <div>
                    <DxButton :text="btn.Save"
                              type="default"
                              styling-mode="contained"
                              @click="onSaveClick()"
                              onmouseover="this.style.backgroundColor='#006db9'" />
                </div>
                <div>
                    <DxButton :text="btn.Delete"
                              type="default"
                              styling-mode="contained"
                              @click="onDeleteClick()"
                              onmouseover="this.style.backgroundColor='#006db9'" />
                </div>
                <div>
                    <DxButton :text="btn.Back"
                              type="default"
                              styling-mode="outlined"
                              @click="onCloseClick()" />
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import axios from "axios";
    import { DxTextBox } from 'devextreme-vue';
    import { DxButton } from 'devextreme-vue/button';
    import { DxDateBox } from 'devextreme-vue/date-box';
    import { DxTabPanel } from 'devextreme-vue/tab-panel';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import { DxDataGrid, DxEditing, DxSearchPanel, DxGroupPanel } from 'devextreme-vue/data-grid';
    import { confirm, alert } from "devextreme/ui/dialog";
    import notify from 'devextreme/ui/notify';
    import $ from 'jquery';
    import { DxItem } from 'devextreme-vue/html-editor';

    const baseUri = "WebApi.asmx/api/WorkFlowListService";
    export default {
        name: 'WorkflowDetail',
        components: {
            DxButton,
            DxTextBox,
            DxDateBox,
            DxItem,
            DxTabPanel,
            DxDataGrid,
            DxEditing,
            DxSelectBox,
            DxSearchPanel,
            DxGroupPanel
        },
        data() {
            return {
                tx: {
                    Title: this.$LanguageProvider.GetResource("Title", "Caption", "Workflow"),
                    TabBaseData: this.$LanguageProvider.GetResource("TabBaseData", "Caption", "Basisdaten"),
                    TabWorkflow: this.$LanguageProvider.GetResource("TabWorkflow", "Caption", "Workflow-Matrix"),
                    WorId: this.$LanguageProvider.GetResource("WorId", "Caption", "ID"),
                    WorName: this.$LanguageProvider.GetResource("WorName", "Caption", "Name"),
                    WorNamePlural: this.$LanguageProvider.GetResource("WorNamePlural", "Caption", "Kurzname Mehrzahl"),
                    WorDescription: this.$LanguageProvider.GetResource("WorDescription", "Caption", "Beschreibung"),
                    InitialStatus: this.$LanguageProvider.GetResource("InitialStatus", "Caption", "Initial Status"),
                    SubmitStatus: this.$LanguageProvider.GetResource("SubmitStatus", "Caption", "Status after Submission"),
                    WorChangedOn: this.$LanguageProvider.GetResource("WorChangedOn", "Caption", "Geändert am"),
                    WorChangedBy: this.$LanguageProvider.GetResource("WorChangedBy", "Caption", "Geändert von"),
                    WorCreatedOn: this.$LanguageProvider.GetResource("WorCreatedOn", "Caption", "Erstellt am"),
                    WorCreatedBy: this.$LanguageProvider.GetResource("WorCreatedBy", "Caption", "Erstellt von")
                },
                btn: {
                    Save: this.$LanguageProvider.GetResource("Save", "Button", "Speichern"),
                    Delete: this.$LanguageProvider.GetResource("Delete", "Button", "Löschen"),
                    Back: this.$LanguageProvider.GetResource("Back", "Button", "Zurück"),
                },
                rowUpdating: (data) => {
                    var newData = Object.assign(data.oldData, data.newData)
                    var names = this.workflowTransition.map(m => {
                        return {
                            Nr: m.Nr,
                            StatusId: m.StatusId
                        }
                    })
                    let fdata = new FormData()
                    fdata.append("statusId", data.key.StatusId)
                    fdata.append("newData", JSON.stringify(newData))
                    fdata.append("names", JSON.stringify(names))
                    axios.post(baseUri + '/UpdateWorkflowTransition', fdata)
                        .then(() => {
                            notify('Der Datensatz wurde erfolgreich aktualisiert')
                        })
                },
            };
        },
        created: function () {

        },
        computed: {
            mandantList() {
                return this.$store.state.mandantStore.mandantList
            },
            publicationList() {
                return this.$store.state.publicationStore.publicationList
            },
            statusList() {
                return this.$store.state.statusStore.statusListSimple
            },
            workflow() {
                return this.$store.state.workflowStore.workflow
            },
            fieldAccess() {
                return this.$store.state.workflowStore.fieldAccess
            },
            workflowTransition() {
                return this.$store.state.workflowStore.workflowTransition
            },
            columns() {
                if (this.workflowTransition) {
                    let columns = [
                        { name: 'StatusId', dataField: 'StatusId', caption: 'ID', dataType: 'number' },
                        { name: 'StaName', dataField: 'StaName', caption: 'Status', dataType: 'string', visible: false },
                        { name: 'StatusName2', dataField: 'StatusName2', caption: 'Status', dataType: 'string' },
                        { name: 'StgName', dataField: 'StgName', caption: 'Statusgruppe', dataType: 'string' },
                    ]
                    let dynCols = this.workflowTransition.map(m => {
                        let status = this.workflowTransition.find(i => i.Nr == m.Nr)
                        return {
                            name: 'Sta' + status.Nr,
                            dataField: 'Sta' + status.Nr,
                            caption: status.StatusName2 + ' (' + status.StatusId + ')',
                            dataType: 'boolean'
                        }
                    })
                    return columns.concat(dynCols)
                }
                return []
            }
        },
        mounted: function () {
            this.$store.dispatch("getWorkflowDetail", {})
            this.$store.dispatch("getMandantList", {})
            this.$store.dispatch("getPublicationList", {})
            this.$store.dispatch("getWfTransition", {})
        },
        watch: {
            workflow: function (newVal) {
                this.$store.dispatch("getStatusListSimple", { worId: newVal ? newVal.WorId : -1 })
            }
        },
        methods: {
            onCloseClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onSaveClick() {
                var formData = new FormData()
                formData.append("data", JSON.stringify(this.workflow))
                axios
                    .post(baseUri + '/SaveDetail', formData)
                    .then(res => {
                        if (res.data.success) { notify(`The changes were saved successfully`); }
                        else { alert(`error: ${res.data.errorMessage}`) }

                    })

            },
            onDeleteClick() {
                let result = confirm("do you really want to delete this record?", "Confirm delete");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        var formData = new FormData()
                        formData.append("data", JSON.stringify(this.workflow))
                        axios
                            .post(baseUri + '/Delete', formData)
                            .then(res => {
                                if (res.data.success) {
                                    notify(`The record has been successfully deleted`);
                                    $("form").attr("action", window.location.pathname + "?action=cancel").submit();
                                }
                                else { alert(`error: ${res.data.errorMessage}`) }

                            })
                    }
                });
            },
            onClick(e) {
                const buttonText = e.component.option('text');
                notify(`The ${this.capitalize(buttonText)} button was clicked`);
            },
            capitalize(text) {
                return text.charAt(0).toUpperCase() + text.slice(1);
            }
        }
    }


</script>
<style>
</style>
